const cardsData = [
   {
      img: "",
      name: "Susan Smith",
      job: "web developer",
      about: "Lorem, ipsum pisicing elit. Repudiandae, dolorem saepe impedit sequi nobis exercitationem fuga maxime omnis unde eaque repellendus, dignissimos ad. Quibusdam consequatur illum nam distinctio corporis odit!",
   },
   {
      img: "",
      name: "Jackson Nalivo",
      job: "system administrator",
      about: "Lorem, ipsum dolor simet consectetur adipisicing elit. Repudiandae, dolorem saepe impedit sequi nobis exercitationem fuga maxime omnis unde eaque repellendus, dignissimos ad. Quibusdam consequatur illum nam poris odit!",
   },
   {
      img: "",
      name: "Diksy Donson",
      job: "firewoman",
      about: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Repudiandae, dolorem saepe impedit tionem fuga maxime omnis unde eaque repellendus, dignissimos ad. Quibusdam consequatur illum nam distinctio corporis odit!",
   },
   {
      img: "",
      name: "Dayana Mitchel",
      job: "social worker",
      about: "Lorem, ipsum dolor simet consectetur adipisicing elit. Repudiandae, dolorem saepe impedit sequi nobis exercitationem fuga maxime omnis unde eaque repellendus, dignissimos ad. Quibusdam consequatur illum nam poris odit!",
   },
   {
      img: "",
      name: "Nelson Trate",
      job: "police officer",
      about: "Lorem, ipsum dolor simet consectetur adipisicing elit. Repudiandae, dolorem saepe impedit sequi nobis exercitationem fuga maxime omnis unde eaque repellendus, dignissimos ad. Quibusdam consequatur illum nam poris odit!",
   },
];

export default cardsData;
